
import MapfishPrintSCHMEncoder from './schmprint/SchmPrintEncoder.ts';
import {drawInnerBuffer} from "./swisspark/swissparkStyle";
import {SWISSPARK_FILL_RESOLUTION} from "./constants";

class PrintService {
  /**
   * Provides a function to create app.print.Service objects used to
   * interact with MapFish Print v3 services.
   *
   * @param {string} printUrl URL to MapFish print web service.
   * @param {angular.$http} $http
   * @ngInject
   */
  constructor(printUrl, $http) {
    /**
     * @type {string}
     * @private
     */
    this.url_ = printUrl;

    /**
     * @type {angular.$http}
     * @private
     */
    this.$http_ = $http;

    this.schmMapfishPrintEncoder = new MapfishPrintSCHMEncoder({
      printUrl: printUrl,
      swissparksFillResolution: SWISSPARK_FILL_RESOLUTION,
      drawInnerBuffer: drawInnerBuffer
    });
  }


  async createSpec(map, scale, printResolution, dpi, layout, format, customAttributes, customizer) {
    return this.schmMapfishPrintEncoder.createSpec(map, scale, printResolution, dpi, layout, format, customAttributes, customizer);
  }

  /**
   * Send a create report request to the MapFish Print service.
   * @param {MapFishPrintSpec} printSpec Print specification.
   * @param {angular.$http.Config=} opt_httpConfig $http config object.
   * @return {angular.$http.HttpPromise} HTTP promise.
   * @export
   */
  createReport(printSpec, opt_httpConfig) {
    const format = printSpec.format || 'pdf';
    const url = `${this.url_}/report.${format}`;
    const httpConfig = /** @type {!angular.$http.Config} */ ({
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    });
    Object.assign(httpConfig, opt_httpConfig !== undefined ? opt_httpConfig : {});
    return this.$http_.post(url, printSpec, httpConfig);
  }

  /**
   * Get the status of a report.
   * @param {string} reference Print report reference.
   * @param {angular.$http.Config=} opt_httpConfig
   * @return {angular.$http.HttpPromise}
   * @export
   */
  getStatus(reference, opt_httpConfig) {
    const httpConfig = opt_httpConfig !== undefined ? opt_httpConfig :
    /** @type {angular.$http.Config} */ ({});
    const url = `${this.url_}/status/${reference}.json`;
    return this.$http_.get(url, httpConfig);
  }

  /**
   * Get the URL of a report.
   * @param {string} reference Print report reference.
   * @return {string} The report URL for this ref.
   * @export
   */
  getReportUrl(reference) {
    return `${this.url_}/report/${reference}`;
  }
}

export default angular.module('appPrintService', []).service('appPrintService', PrintService);
